import config from 'config';

import { CompletedSignupV4Data } from 'domains/signupv4/Parent/signupMachineV4';

/** Returns the external insurance form URL */
const getInsuranceFormURL = (context: CompletedSignupV4Data) => {
  const queryParams = new URLSearchParams({
    // when we create a lead we receive a generated Id to be used when the contact gets created
    // the schedulingID is the contact ID in Cue
    // see: https://github.com/expressable/salesforce-services/blob/main/functions/salesforce/leads/create-lead-v2/src/index.ts#L18
    cueid: context.schedulingID,
    cname: context.lastName,
    me: context.target === 'adult' ? 'yes' : 'no',
    phone: context.phoneNumber,
    email: context.email,
  }).toString();

  return `${config.get('salesforceInsuranceURL')}?${queryParams.toString()}`;
};

export const getRedirectAfterSignupV4Complete = (context: CompletedSignupV4Data): string => {
  if (context.insuranceInfo.useInsurance) {
    return getInsuranceFormURL(context);
  }
  return config.get('marketingThankYouURL') as string;
};
